var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCroed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 13-4.15-4.05a7.847 7.847 0 0 1-1.313-1.662A3.847 3.847 0 0 1 10 5.3c0-.917.32-1.696.963-2.337C11.604 2.32 12.383 2 13.3 2a3.41 3.41 0 0 1 1.5.337c.467.225.867.53 1.2.913a3.702 3.702 0 0 1 1.2-.913A3.41 3.41 0 0 1 18.7 2c.917 0 1.696.32 2.338.962.641.642.962 1.421.962 2.338 0 .717-.175 1.38-.525 1.987a7.533 7.533 0 0 1-1.3 1.663L16 13Zm0-2.8 2.725-2.675c.317-.317.608-.654.875-1.013.267-.358.4-.762.4-1.212 0-.367-.125-.675-.375-.925A1.257 1.257 0 0 0 18.7 4c-.233 0-.454.046-.662.138-.209.091-.388.229-.538.412L16 6.35l-1.5-1.8c-.15-.183-.33-.32-.537-.412A1.627 1.627 0 0 0 13.3 4c-.367 0-.675.125-.925.375S12 4.933 12 5.3c0 .45.133.854.4 1.213.267.358.558.695.875 1.012L16 10.2Zm-9 8.3 6.95 1.9 5.95-1.85a1.142 1.142 0 0 0-.362-.387A.93.93 0 0 0 19 18h-5.05a9.1 9.1 0 0 1-1.075-.05 3.952 3.952 0 0 1-.825-.2l-2.325-.775.55-1.95 2.025.675c.283.083.617.15 1 .2.383.05.95.083 1.7.1a.949.949 0 0 0-.162-.525.753.753 0 0 0-.388-.325L8.6 13H7v5.5ZM1 22V11h7.6c.117 0 .233.012.35.037.117.025.225.055.325.088L15.15 13.3c.55.2.996.55 1.338 1.05.341.5.512 1.05.512 1.65h2c.833 0 1.542.275 2.125.825.583.55.875 1.275.875 2.175v1l-8 2.5-7-1.95V22H1Zm2-2h2v-7H3v7Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroed);
export default __webpack_public_path__ + "static/media/croed.cc51c3ef5d3914f3dee663db83772cc2.svg";
export { ForwardRef as ReactComponent };